/* TODO: Удалить строки с игнорированием TS в задаче PUB-4328 (Оптимизация обработки кодов) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { type Ref } from 'vue'


export function hasEnChild(codeItems: any, code: any) {
  if (code.is_en) {
    return true
  }

  if (code.children?.length) {
    for (const id of code.children) {
      const hasEn = hasEnChild(codeItems, codeItems[id])
      if (hasEn) {
        return true
      }
    }
  }
  return false
}

export function hasOnlyEnChildren(codeItems: any, code: any) {
  if (code.is_en) {
    return true
  }

  if (code.children?.length) {
    return code.children.reduce((acc, id) => {
      if (acc === false) {
        return acc
      }
      const child = codeItems[id]
      if (child.children?.length) {
        return hasOnlyEnChildren(codeItems, child)
      }
      acc = child.is_en
      return acc
    }, true)
  }
  return code.is_en
}

export function getCodeIdByPath(
  allCodes: Ref<Record<string, any>> | Record<string, any> | undefined,
  path: string,
) {
  const codes = allCodes?.value ?? allCodes // сюда приходят и ref и plain

  if (!codes) {
    return null
  }

  const code = Object.values(codes).find(
    (code) => code?.path === String(path),
  )

  return code
    ? code.id
    : null
}

export function getCodeUidByPath(allCodesByUid: Ref<Record<string, any>> | undefined, path: string) {
  if (!allCodesByUid?.value) {
    return null
  }
  const code = Object.values(allCodesByUid.value).find(
    (code) => code.path === String(path),
  )
  return code
    ? code.uid
    : null
}
// function sortAlphaBy(array, key) {
//   return array.sort((a, b) => {
//     const valA = a[key].toLowerCase()
//     const valB = b[key].toLowerCase()
//     if (valA < valB) return -1
//     if (valA > valB) return 1
//     return 0
//   })
// }

// /**
//  * Формирует список кодов, разбитый по их корневым категориям.
//  * Корневым категориям добавляется ключ `isGroup`, чтобы отличать их внутри `NewsCodesList`
//  * @returns {Object[]}
//  */
// export function groupCodes(codes) {
//   // Получаем корневые категории, отсортированные по названию:
//   const groups = sortAlphaBy(
//     $uniqBy(
//       codes.map(item => item?.category).filter(item => item),
//       "id"
//     ),
//     "name"
//   )
//   return groups.reduce((acc, cat) => {
//     acc.push({ isGroup: true, id: cat.id, name: cat.name })
//     // Получаем коды для каждой категории, отсортированные по названию:
//     const items = sortAlphaBy(
//       codes.filter(item => item.category?.id === cat.id),
//       "name"
//     )
//     return [...acc, ...items]
//   }, [])
// }
